module.exports = __webpack_public_path__ + "img/burger.b57bf98e.svg";